const SendIcon = () => {
  return (
    <svg fill="none" viewBox="0 0 33 32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.66675 25.6667L16.3334 6.33337L26.0001 25.6667L16.3334 21L6.66675 25.6667Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M16.3335 20.6667V17"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

export default SendIcon
